<div class="content">
  <div>
    <button class="button-create" mat-button (click)="createTimer()">
      Añadir Temporizador
    </button>
  </div>
  <mat-tab-group>
    <mat-tab label="Temporizadores configurados">
      <div class="table-container">
        <table mat-table [dataSource]="dataSource" class="table">
          <!-- Alerta Column -->
          <ng-container matColumnDef="tipo_alerta">
            <th mat-header-cell *matHeaderCellDef>Alerta</th>
            <td mat-cell *matCellDef="let element">
              {{ alerta_valor[element.tipo_alerta] }}
            </td>
          </ng-container>
          <!-- Unidades Column -->
          <ng-container matColumnDef="units">
            <th mat-header-cell *matHeaderCellDef>Unidades</th>
            <td mat-cell *matCellDef="let element">
              <!-- {{ getNameUnit(element.unit) }} -->
              {{ element.unit[0].name }}
            </td>
          </ng-container>

          <!-- Escala de tiempo Column -->
          <ng-container matColumnDef="escala">
            <th mat-header-cell *matHeaderCellDef>Escala de tiempo</th>
            <td mat-cell *matCellDef="let element">
              {{ capitalize(element.escala) }}
            </td>
          </ng-container>

          <!-- Tiempo Column -->
          <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef>Tiempo</th>
            <td mat-cell *matCellDef="let element" class="valor_text">
              {{ element.valor }} {{ element.escala }}
            </td>
          </ng-container>

          <!-- Acciones Column -->
          <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>Acciones</th>
            <td mat-cell *matCellDef="let element">
              <button mat-icon-button [matMenuTriggerFor]="menu">
                <mat-icon>more_horiz</mat-icon>
              </button>
              <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="editTimer(element)">
                  <mat-icon>edit</mat-icon>
                  <span>Editar</span>
                </button>
                <button mat-menu-item (click)="deleteTimer(element._id)">
                  <mat-icon>delete</mat-icon>
                  <span>Eliminar</span>
                </button>
              </mat-menu>
            </td>
          </ng-container>

          <!-- Header and Row Definitions -->
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        </table>

        <!-- Paginator -->
        <mat-paginator
          [pageSizeOptions]="[5, 10, 20]"
          showFirstLastButtons
        ></mat-paginator>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
